var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService, prepareParams, } from "./baseService";
class DownloadWorkshiftCSVService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "download_workshift_csv";
    }
    generateTimesheetsCSVFile(customCompany, startDate, endDate) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            yield this.api.post(`${this.controllerName}/custom/generate/`, {}, {
                params: {
                    where: {
                        company: customCompany,
                        start: startDate,
                        end: endDate,
                    },
                },
            });
            return;
        });
    }
    cancelTimesheetsCSVFile() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.api.delete(`${this.controllerName}/custom/cancelGenerate/`, {});
        });
    }
    timesheetsCSVFileStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const data = yield this.api.get(`${this.controllerName}/custom/information`);
            return data;
        });
    }
    downloadTimesheetsCSVFile() {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = Object.assign(Object.assign({}, this.getDefaultHeaders()), { "Content-Type": "text/csv" });
            const { data } = yield this.api.get(`${this.controllerName}/custom/url`, {
                headers,
            });
            return data;
        });
    }
    getCSVUrl(id, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = prepareParams(options);
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data: { data: { url }, }, } = yield this.api.get(`${this.controllerName}/url/${id}`, { params });
            return url;
        });
    }
    getCustomCSVUrl(fileName, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = prepareParams(options);
            const headers = Object.assign(Object.assign({}, this.getDefaultHeaders()), { "Content-Type": "text/csv" });
            const { data } = yield this.api.get(`${this.controllerName}/custom`, {
                headers,
                params,
            });
            const DELETE_BLOB_DELAY_MS_TIME = 100;
            const blob = new Blob([data], { type: "data:text/csv;charset=utf-8," });
            const blobURL = window.URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.download = fileName;
            anchor.href = blobURL;
            anchor.dataset.downloadurl = [
                "text/csv",
                anchor.download,
                anchor.href,
            ].join(":");
            anchor.click();
            setTimeout(() => {
                URL.revokeObjectURL(blobURL);
            }, DELETE_BLOB_DELAY_MS_TIME);
            return Promise.resolve({
                data: {},
            });
        });
    }
    generateExcessHourTimesheetsCSVFile(customCompany, startDate, endDate) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            yield this.api.post(`${this.controllerName}/custom/excess_hours_report/generate/`, {}, {
                params: {
                    where: {
                        company: customCompany,
                        start: startDate,
                        end: endDate,
                    },
                },
            });
            return;
        });
    }
    cancelExcessHourTimesheetsCSVFile() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.api.delete(`${this.controllerName}/custom/excess_hours_report/cancelGenerate/`, {});
        });
    }
    timesheetsExcessHourCSVFileStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const data = yield this.api.get(`${this.controllerName}/custom/excess_hours_report/information`);
            return data;
        });
    }
    downloadExcessHourTimesheetsCSVFile() {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = Object.assign(Object.assign({}, this.getDefaultHeaders()), { "Content-Type": "text/csv" });
            const { data } = yield this.api.get(`${this.controllerName}/custom/excess_hours_report/url`, {
                headers,
            });
            return data;
        });
    }
}
export const downloadWorkshiftCSVService = new DownloadWorkshiftCSVService();
//# sourceMappingURL=downloadWorkshiftCSVService.js.map